/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Solo_PriceInputs */

const en_cp_p_solo_price = /** @type {(inputs: Cp_P_Solo_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 69k`)
};

const id_cp_p_solo_price = /** @type {(inputs: Cp_P_Solo_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 69 rb`)
};

/**
* | output |
* | --- |
* | "IDR 69k" |
*
* @param {Cp_P_Solo_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_solo_price = /** @type {((inputs?: Cp_P_Solo_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Solo_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_solo_price(inputs)
	return en_cp_p_solo_price(inputs)
});